export function getRegion () {
  // Uses the localisePicker element and tries to get region
  const element = document.querySelector('#localisePicker');
  if (element) {
    return element.getAttribute('data-region');
  }
  return 'gb-london';
}
